import React, { useState } from 'react';
import classNames from 'classnames';
import Button from '../../components/Button';
import DeltaPreview from '../../components/DeltaPreview';
import { MagneticWallItemWithAvatar } from '../MagneticWallItem';
import AnnotationIcon, { AnnotationIconContainer } from './AnnotationIcon';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import isContentEmpty from '../utils/isContentEmpty';
import styles from './AnnotationPreview.module.scss';
import { MentionBaseProvider } from '../../editor/mentions/MentionBase';

const ANNOTATION_PREVIEW_FRAGMENT = gql(`
  fragment AnnotationPreview_annotation on PublicAnnotationFields {
    id
    content
    link
    linkText
  }
`);

interface AnnotationPreviewProps {
  annotation: DocumentType<typeof ANNOTATION_PREVIEW_FRAGMENT>;
}

const MAX_LINES_PREVIEW = 4;

const AnnotationPreview = ({ annotation }: AnnotationPreviewProps) => {
  const [isShowingMore, setIsShowingMore] = useState(false);
  const [canBeClamped, setCanBeClamped] = useState<boolean>(false);

  return (
    <MagneticWallItemWithAvatar
      avatar={
        <AnnotationIconContainer>
          <AnnotationIcon />
        </AnnotationIconContainer>
      }
      innerTestId="annotation-preview-content"
    >
      {isContentEmpty(annotation.content) ? (
        <a
          className={styles.link}
          href={annotation.link ?? '#'}
          target="_blank"
          rel="noreferrer"
        >
          {annotation.linkText ?? annotation.link ?? ''}
        </a>
      ) : (
        <div
          className={classNames('annotation-preview', styles.annotationPreview)}
        >
          <MentionBaseProvider containerType="comment">
            <DeltaPreview
              typography="comment"
              maxLines={MAX_LINES_PREVIEW}
              disableLineClamp={isShowingMore}
              content={annotation.content}
              onCanBeClampedChange={setCanBeClamped}
            />
          </MentionBaseProvider>
        </div>
      )}

      {canBeClamped && (
        <Button
          variant="link"
          size="micro"
          onClick={() => setIsShowingMore(!isShowingMore)}
        >
          {isShowingMore ? 'Show less' : 'Show more'}
        </Button>
      )}
    </MagneticWallItemWithAvatar>
  );
};

export default AnnotationPreview;
